// Print-only projection. Never sort/mutate the basket or recalculate a full sale.
export const isTobaccoCategory = name => String(name || '').trim().toLocaleLowerCase('id-ID') === 'rokok';

export function catalogReceiptItems(items, products = [], categories = []) {
  const productMap = new Map(products.map(product => [product.id, product]));
  const categoryMap = new Map(categories.map(category => [category.id, category.name]));
  return items.map(item => {
    if (typeof item.receipt_tobacco === 'boolean') return item;
    const product = productMap.get(item.product_id);
    if (!product) return item;
    if (product.category_id && !categoryMap.has(product.category_id)) return item;
    return { ...item, receipt_tobacco: isTobaccoCategory(categoryMap.get(product.category_id)) };
  });
}

export function receiptGroups(items = []) {
  const tobacco = items.filter(item => item.receipt_tobacco === true);
  const other = items.filter(item => item.receipt_tobacco !== true);
  return { items: [...tobacco, ...other], separator: tobacco.length && other.length ? tobacco.length : -1 };
}

export const canPrintNonTobacco = items => items.length > 0
  && items.every(item => typeof item.receipt_tobacco === 'boolean')
  && items.some(item => item.receipt_tobacco === false);

export const compactReceiptReference = tx => tx.queue_number || (tx.invoice_no !== 'DRAFT' ? tx.invoice_no : '') || 'Belum dikirim';

export function nonTobaccoReceipt(tx) {
  if (!canPrintNonTobacco(tx.items || [])) throw new Error('Tidak ada barang nonrokok, atau kategori barang belum tersedia.');
  const items = tx.items.filter(item => item.receipt_tobacco === false);
  const subtotal = Math.round(items.reduce((sum, item) => sum + Math.max(0, Number(item.qty) * Number(item.price) - Number(item.discount || 0)), 0) * 100) / 100;
  return { ...tx, items, receipt_scope: 'non_tobacco', subtotal, total: subtotal,
    receipt_discount_excluded: tx.receipt_discount_excluded || Number(tx.discount || 0) > 0,
    discount: 0, previous_debts: [], settlement_total: 0, fee: 0, grand_total: subtotal,
    payments: [], checkout_payments: [], paid: 0, change: 0, credit: 0, return_credit_applied: 0 };
}
